// @flow
import * as React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { WHITE_COLOR, PRIMARY_COLOR } from 'coooltv-js-shared/src/styles/common';

const styles = StyleSheet.create({
    center: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: WHITE_COLOR,
    },
});

const AbsoluteActivityIndicator = (): React.Node => (
    <View style={[StyleSheet.absoluteFill, styles.center]}>
        <ActivityIndicator size="large" color={PRIMARY_COLOR} />
    </View>
);

export default AbsoluteActivityIndicator;
